const productPaths = {
  SEARCH_PRODUCT_SKU: "/search",
};

export default productPaths;
